import { render, staticRenderFns } from "./UserOfferSingle.vue?vue&type=template&id=b03c8976&scoped=true&"
import script from "./UserOfferSingle.vue?vue&type=script&lang=js&"
export * from "./UserOfferSingle.vue?vue&type=script&lang=js&"
import style0 from "./UserOfferSingle.vue?vue&type=style&index=0&id=b03c8976&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b03c8976",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VImg } from 'vuetify/lib/components/VImg';
import { VLayout } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VCardText,VContainer,VDialog,VFlex,VImg,VLayout})
